import { accuracy } from '../consts/svgTemplate';

export const getNumberWithAccuracy = (number) => Number(number.toFixed(accuracy));
